<div class="information-block" [ngStyle]="{ marginBottom: marginBottom }">
  <div class="information-block-content">
    <div class="information-block-header">
      <p class="title">{{ title }}</p>
    </div>
    <p class="text">{{ description }}</p>
    <div *ngFor="let extra of extras" class="information-block-extras">
      <p class="title">{{ extra.title }}</p>
      <p class="text">{{ extra.description }}</p>
    </div>
    <div class="link-wrapper" *ngIf="linkLocation">
      <app-external-link [link]="linkLocation">{{ linkTitle }}</app-external-link>
    </div>
  </div>
</div>
